import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchgetCommunity, repairCount, surveyCount, leaseContractCount, complaintManageCount, recodeOutCount, leaseContractCountList, houseCount, fetchNotice } from "@/api/PMS/zhlg/zhlg.js"; // import { NavbarHome } from "@/layout/components";

import { selectAreaCityNode } from "@/api/PMS/treeList/index.js";
import { mapGetters, mapState } from "vuex";
import { warrantyChart, complaintsChart, lackStatisticalChart, earlyWarningChart } from "./components"; // import {
//   repairCount,
//   surveyCount,
//   complaintManageCount,
//   houseCount,
//   recodeOutCount,
//   list,
//   leaseContractCount,
//   leaseContractCountList,
// } from "@/api/system/dashboard/dashbord.js";

export default {
  name: "layout",
  components: {
    // Navbar: NavbarHome,
    warrantyChart: warrantyChart,
    complaintsChart: complaintsChart,
    lackStatisticalChart: lackStatisticalChart,
    earlyWarningChart: earlyWarningChart
  },
  data: function data() {
    return {
      buildList: [],
      userName: '',
      linkageVisible: true,
      // 社区切换参数
      listQuery: {},
      // 可租赁房源资源统计
      statisticsWarranty: {},
      // 最新满意度调查问卷
      surveyCount: [],
      // 近七天投诉统计
      complaintManageCount: [],
      // 可租赁房源资源统计
      houseCount: {},
      // 应收已收欠费统计
      recodeOutCount: {},
      // 最新通知
      noticeList: [],
      // 近七天合同到期告警数
      leaseContractCount: [],
      // 近七天合同到期告警数列表
      leaseContractCountList: [],
      chartData1: [],
      lendName1: [],
      total1: [],
      chartData2: [],
      lendName2: [],
      chartData3: [],
      lendName3: [],
      total3: [],
      chartData4: [],
      lendName4: [],
      data: [],
      cascaderItem: [],
      communityIds: [],
      options: [],
      // 进度条
      customColor: "rgb(42,184,254)",
      customColor2: "rgb(245,214,0)",
      processedCount: 0,
      untreatedCount: 0,
      // 菜单过滤
      newList: [],
      defalutMenuList: [],
      //已出账单、发布公告 合同到期预警为最新通知应收已收欠费统计、最新通知、近七天合同到期预警数的更多按钮；租户管理包含可租赁房源资源统计下面三个按钮是否可跳转（子菜单，跳转菜单）
      bannerMenuIdList: [{
        name: "发布公告",
        menuId: 1318,
        isDisable: true
      }, {
        name: "已出账单",
        menuId: 1247,
        isDisable: true
      }, {
        name: "合同到期预警",
        menuId: 1322,
        isDisable: true
      }, {
        name: "资源管理-房屋",
        menuId: 1145,
        isDisable: true
      }, {
        name: "合同管理",
        menuId: 1281,
        isDisable: true
      }],
      propstree: {
        label: "name",
        value: "areaId",
        children: "pmsTree",
        multiple: true
      },
      isChoosed: "",
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      dates: undefined,
      tableHeight: "34vh",
      // housingResource:[{},{}],
      customClass: 'bhxcsq-new-select'
    };
  },
  created: function created() {
    this.chooseData("week");
    this.userName = this.$store.getters.name;

    if (this.userType === 32 || this.userType === 16) {
      this.loadMenuTree();
      this.cascaderItem;
    } else {} // this.handleFilter()
    //收费管理、通知管理、租户管理为最新通知应收已收欠费统计、最新通知、近七天合同到期预警数父级菜单


    this.defalutMenuList = [{
      name: "收费管理",
      menuId: 1206
    }, {
      name: "通知管理",
      menuId: 1316
    }, {
      name: "租户管理",
      menuId: 1280
    }, //  可租赁房源资源统计上面三个按钮 是否可跳转
    {
      name: "资源管理",
      menuId: 1142
    }]; // if (this.userType === 32 || this.userType === 16) {
    //   this.defalutMenuList = [
    //     { name: "通知公告查看", menuId: 1316 },
    //     { name: "收费管理", menuId: 1206 },
    //     { name: "合同记录查看", menuId: 1280 },
    //     { name: "资源管理", menuId: 1142 },
    //   ];
    //   this.bannerMenuIdList = [
    //     { name: "通知公告查看", menuId: 1551, isDisable: true },
    //     { name: "已出账单查看", menuId: 1555, isDisable: true },
    //     { name: "合同记录查看", menuId: 1557, isDisable: true },
    //     { name: "资源管理-房屋", menuId: 1561, isDisable: true },
    //     // { name: "合同管理", menuId: 1557, isDisable: true },
    //   ];
    // }
    // 判断用户是否拥有跳转连接的菜单

    this.newList = [];
    console.log(this.admin_routers);
    this.getNewMenu(this.admin_routers);
    console.log(this.userType);

    var _iterator = _createForOfIteratorHelper(this.bannerMenuIdList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        this.menuEmpty(this.newList, key);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    console.log(this.bannerMenuIdList);
    this.getDistrict();
  },
  computed: _objectSpread({
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }, mapState({
    userType: function userType(state) {
      return state.user.userType;
    },
    admin_routers: function admin_routers(state) {
      return state.permission.adminRouters;
    } // 后端生成菜单

  })),
  methods: {
    logout: function logout() {
      var _this = this;

      this.$confirm('您确定要退出, 是否继续?', '提示').then(function () {
        _this.$store.dispatch('LogOut').then(function () {
          location.reload();
        });
      });
    },
    getFullCreeen: function getFullCreeen() {
      var element = document.documentElement;

      if (this.fullscreen) {
        this.creenClose = false;

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        this.creenClose = true;

        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }

      this.fullscreen = !this.fullscreen;
    },
    manage: function manage() {
      this.$router.push({
        name: 'dashboard'
      });
    },
    getNode: function getNode(dataList) {
      var _this2 = this;

      console.log(dataList);

      if (this.userType === 32 || this.userType === 16) {
        this.listQuery.communityIds = [];

        if (dataList && dataList.length > 0) {
          dataList.forEach(function (item) {
            _this2.listQuery.communityIds.push(item[item.length - 1]);
          });
        }
      } else {}

      this.handleFilter();
    },
    // 默认选中楼宇--身份16，32物业或区域管理员时
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 1
      };
      selectAreaCityNode(treeQuery).then(function (response) {
        _this3.options = response.data.data; // getNode

        var cascaderItem = [];
        console.log(_this3.options);

        if (_this3.options.length !== 0) {
          cascaderItem.push(_this3.options[0].areaId);

          if (_this3.options[0].pmsTree.length !== 0) {
            // this.cascaderItem.push(this.options[0].areaId)
            cascaderItem.push(_this3.options[0].pmsTree[0].areaId);

            if (_this3.options[0].pmsTree[0].pmsTree.length !== 0) {
              cascaderItem.push(_this3.options[0].pmsTree[0].pmsTree[0].areaId);

              if (_this3.options[0].pmsTree[0].pmsTree[0].pmsTree !== 0) {
                cascaderItem.push(_this3.options[0].pmsTree[0].pmsTree[0].pmsTree[0].areaId);
              }
            }
          }
        }

        _this3.cascaderItem.push(cascaderItem);

        _this3.getNode(_this3.cascaderItem); // this.handleFilter();

      });
    },
    norma: function norma(ids, childrens) {
      // console.log('路径', childrens)
      for (var i = 0; i < childrens.length; i++) {
        if (ids === childrens[i].menuId) {
          this.newList.push({
            children: childrens[i].children,
            path: childrens[i].path,
            menuId: childrens[i].menuId,
            menuUpId: childrens[i].menuUpId,
            meta: childrens[i].meta,
            name: childrens[i].name
          });
        }
      }
    },
    //  默认选择搜索时间 今日 近一周 近一月
    chooseData: function chooseData(data) {
      var date = data;

      if (date === "data") {
        this.isChoosed = "data";
        this.dates = [new Date(), new Date()];
      } else if (date === "week") {
        this.isChoosed = "week";
        var now = new Date(); // 获取当前周的第一天

        var start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (now.getDay() + 6) % 7);
        console.log(new Date().getDay(), now.getDay(), now.getDate()); // 获取本周的最后一天

        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (now.getDay() + 6) % 7 + 6);
        start.setTime(start.getTime());
        this.dates = [start, end];
      } else if (date === "month") {
        this.isChoosed = "month";

        var _now = new Date(); // 获取当前月的第一天


        var _start = new Date(_now.getFullYear(), _now.getMonth(), 1);

        var _end = new Date(_now.getFullYear(), _now.getMonth() + 1, 0);

        _start.setTime(_start.getTime());

        _end.setTime(_end.getTime());

        this.dates = [_start, _end];
      } else if (date === "year") {
        this.isChoosed = "year";

        var _now2 = new Date(); // 获取当前月的第一天


        var _start2 = new Date(_now2.getFullYear(), 0, 1);

        var _end2 = new Date(_now2.getFullYear(), 12, 0);

        _start2.setTime(_start2.getTime());

        _end2.setTime(_end2.getTime());

        this.dates = [_start2, _end2];
      }
    },
    lackChooseData: function lackChooseData(value) {
      // console.log(value)
      this.getRecodeOutCount();
    },
    // getNewMenu menuEmpty handleMenuSelect menuFormat 用于判断用户是否拥有该跳转连接菜单
    getNewMenu: function getNewMenu(meanuList) {
      for (var i = 0; i < this.defalutMenuList.length; i++) {
        if (meanuList == null) {
          return null;
        }

        for (var j = 0; j < meanuList.length; j++) {
          if (meanuList[j].menuId) {
            if (this.defalutMenuList[i].menuId === meanuList[j].menuId) {
              this.newList.push({
                children: meanuList[j].children,
                path: meanuList[j].path,
                menuId: meanuList[j].menuId,
                menuUpId: meanuList[j].menuUpId,
                meta: meanuList[j].meta,
                name: meanuList[j].name
              });
            } else {
              if (meanuList[j].children) {
                this.norma(this.defalutMenuList[i].menuId, meanuList[j].children);
              }
            }
          }
        }
      }

      console.log("this.newList");
      console.log(this.newList);
      console.log("---this.newList---");
    },
    menuEmpty: function menuEmpty(route, menu) {
      var _this4 = this;

      var findMenu = [];

      if (route.length) {
        route.filter(function (item) {
          if (item.menuId === menu.menuId) {
            var index = _this4.bannerMenuIdList.findIndex(function (item) {
              return item.menuId === menu.menuId;
            });

            console.log(index, item.menuId, menu.menuId, menu, item, _this4.bannerMenuIdList);
            _this4.bannerMenuIdList[index].isDisable = false;
            return true;
          } else {
            _this4.menuEmpty(item, menu);

            return false;
          }
        });
      } else {
        if (route.children) {
          findMenu = route.children.filter(function (item) {
            if (item.menuId === menu.menuId) {
              var index = _this4.bannerMenuIdList.findIndex(function (item) {
                return item.menuId === menu.menuId;
              });

              _this4.bannerMenuIdList[index].isDisable = false;
              return true;
            } else {
              _this4.menuEmpty(item, menu);

              return false;
            }
          });
        }

        return findMenu;
      }
    },
    handleMenuSelect: function handleMenuSelect(menu, parameter) {
      // this.menuPathArr = []
      console.log(parameter);
      this.menuFormat(this.newList, menu, parameter); // 页面跳转
      //   console.log('跳转菜单', menu, 'id', menu.menuId)
      // this.$store.dispatch('ChooseRouters', menu) // 左侧sidebar 的内容部分
    },
    menuFormat: function menuFormat(route, menu, parameter) {
      var _this5 = this;

      var findMenu = [];

      if (route.length) {
        findMenu = route.filter(function (item) {
          if (item.menuId === menu.menuId) {
            return true;
          } else {
            _this5.menuFormat(item, menu, parameter);

            return false;
          }
        });
        var menuPath = "/" + findMenu[0].path;
        console.log("menuPath+++");
        console.log(menuPath, route);

        if (parameter === undefined) {
          console.log("parameter", parameter);
          this.$router.push(menuPath);
        } else {
          console.log("parameter", parameter);

          if (this.userType === 32 || this.userType === 16) {
            console.log(this.cascaderItem);
            parameter.cascaderItem = this.cascaderItem ? JSON.stringify(this.cascaderItem) : [];
          }

          this.$router.push({
            path: menuPath,
            query: parameter
          });
        }

        this.$store.commit("app/CHANGE_SIDEBAR", true);
        document.querySelector(".main-container").style.marginLeft = "210px";
        console.log("跳转菜单", menu);
        this.$store.dispatch("ChooseRouters", menu);
      } else {
        if (route.children) {
          findMenu = route.children.filter(function (item) {
            if (item.menuId === menu.menuId) {
              return true;
            } else {
              _this5.menuFormat(item, menu, parameter);

              return false;
            }
          });

          if (findMenu.length) {
            var _menuPath = route.path + "/" + findMenu[0].path;

            if (parameter === undefined) {
              console.log("parameter", parameter);
              this.$router.push(_menuPath);
            } else {
              if (this.userType === 32 || this.userType === 16) {
                console.log(JSON.stringify(this.cascaderItem));
                parameter.cascaderItem = this.cascaderItem ? JSON.stringify(this.cascaderItem) : [];
              }

              this.$router.push({
                path: _menuPath,
                query: parameter
              });
            }

            this.$store.commit("app/CHANGE_SIDEBAR", true);
            document.querySelector(".main-container").style.marginLeft = "210px";
            this.$store.dispatch("ChooseRouters", menu); // 左侧sidebar 的内容部分
          }
        }

        return findMenu;
      }
    },
    // 切换楼宇
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
      this.getRepairCount();
      this.getSurveyCount();
      this.getComplaintManageCount();
      this.getHouseCount();
      this.getRecodeOutCount();
      this.getLeaseContractCount();
      this.getLeaseContractCountList();
    },
    getDistrict: function getDistrict() {
      var _this6 = this;

      fetchgetCommunity({}).then(function (response) {
        _this6.buildList = response.data.data;
        _this6.listQuery.communityIds = [_this6.buildList[0].communityId.toString()];
        _this6.communityIds = [_this6.buildList[0].communityId.toString()];

        _this6.handleFilter();
      });
    },
    // 报修统计
    getRepairCount: function getRepairCount() {
      var _this7 = this;

      repairCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this7.statisticsWarranty = res.data.data;
          _this7.chartData1 = [_this7.statisticsWarranty.processedCount, _this7.statisticsWarranty.untreatedCount];

          if (_this7.statisticsWarranty.repairCount === 0) {
            _this7.processedCount = 0;
            _this7.untreatedCount = 0;
          } else {
            _this7.processedCount = +(parseInt(_this7.statisticsWarranty.processedCount) / parseInt(_this7.statisticsWarranty.repairCount) * 100).toFixed(2); // +为了转为number，toFixed(2)得到字符串类型

            _this7.untreatedCount = +(parseInt(_this7.statisticsWarranty.untreatedCount) / parseInt(_this7.statisticsWarranty.repairCount) * 100).toFixed(2);
          }

          console.log("已处理", _this7.untreatedCount, _this7.processedCount);
          _this7.lendName1 = ["已处理", "未处理"];
          _this7.total1 = _this7.statisticsWarranty.repairCount;
        }
      });
    },
    // 最新满意度调查问卷
    getSurveyCount: function getSurveyCount() {
      var _this8 = this;

      var listQuery = this.listQuery;
      listQuery.limit = 7;
      this.surveyCount = [];
      surveyCount(listQuery).then(function (res) {
        if (res.data.code === 200) {
          // this.surveyCount = res.data.data;
          if (res.data.data.length >= 5) {
            _this8.surveyCount = res.data.data.slice(0, 5);
          } else {
            // this.surveyCount = res.data.data;
            _this8.surveyCount = [{
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }];
          }
        }
      });
    },
    // 近七天投诉统计
    getComplaintManageCount: function getComplaintManageCount() {
      var _this9 = this;

      complaintManageCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          // console.log()
          _this9.complaintManageCount = res.data.data;
          _this9.chartData2 = [];
          _this9.lendName2 = []; // console.log(this.complaintManageCount)
          // console.log(this.complaintManageCount)

          _this9.complaintManageCount.forEach(function (item) {
            _this9.chartData2.push(item.totalOrder);

            _this9.lendName2.push(item.dealTime);
          });
        }
      });
    },
    // 可租赁房源资源统计
    getHouseCount: function getHouseCount() {
      var _this10 = this;

      houseCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this10.houseCount = res.data.data;
        }
      });
    },
    // 应收已收欠费统计
    getRecodeOutCount: function getRecodeOutCount() {
      var _this11 = this;

      var listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.beginDate = this.dates[0];
      listQuery.endDate = this.dates[1];
      recodeOutCount(listQuery).then(function (res) {
        if (res.data.code === 200) {
          // console.log('getRecodeOutCount',this.recodeOutCount)
          if (res.data.data === null) {
            _this11.recodeOutCount.recodeCountDetails = [];
            _this11.total3 = 0;
            _this11.chartData3 = [0, 0];
            _this11.lendName3 = ["欠费", "实收"];
          } else {
            _this11.recodeOutCount = res.data.data;
            _this11.total3 = _this11.recodeOutCount.totalAmount;
            _this11.chartData3 = [_this11.recodeOutCount.arrearageCount, _this11.recodeOutCount.receivedCount];
            _this11.lendName3 = ["欠费", "实收"]; // this.recodeOutCount.recodeCountDetails = [{chargeName:'123'},{chargeName:'123'},{chargeName:'123'},
            // {chargeName:'123'},{chargeName:'123'},{chargeName:'123'},{chargeName:'123'},{chargeName:'123'},{chargeName:'123'},]
          } //     chartData3:[],
          // lendName3:[],
          // total3:[],

        }
      });
    },
    // 最新通知
    getList: function getList() {
      var _this12 = this;

      var listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.limit = 6;
      listQuery.page = 1;
      listQuery.publishStatus = 1;
      console.log(listQuery);
      fetchNotice(listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this12.noticeList = res.data.data;
        }
      });
    },
    // 近七天合同到期告警数
    getLeaseContractCount: function getLeaseContractCount() {
      var _this13 = this;

      leaseContractCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this13.leaseContractCount = res.data.data;
          _this13.chartData4 = [];
          _this13.lendName4 = [];

          _this13.leaseContractCount.forEach(function (item) {
            _this13.chartData4.push(item.totalOrder);

            _this13.lendName4.push(item.dealTime);
          }); // chartData4:[],
          // lendName4:[],

        }
      });
    },
    // 近七天合同到期告警数列表
    getLeaseContractCountList: function getLeaseContractCountList() {
      var _this14 = this;

      var listQuery = this.listQuery;
      listQuery.page = 1;
      listQuery.limit = 7;
      leaseContractCountList(listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this14.leaseContractCountList = res.data.data; // this.leaseContractCountList = [{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},
          // {contractNo: '13'},{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},]
        }
      });
    }
  }
};